export default [
	{
	    path: '/feiyong/detail',
	    name: '/feiyong/detail',
	    // which is lazy-loaded when the route is visited.
	    component: () => import( '@/views/feiyong/detail.vue'),
	
	},
	{
	    path: '/feiyong/main',
	    name: '/feiyong/main',
	    // which is lazy-loaded when the route is visited.
	    component: () => import( '@/views/feiyong/main.vue'),
	
	}
]